<template>
  <div>
    <b-container>
      <div v-if="loading">
        <div class="text-center text-primary my-2 mt-5 page-content">
          <b-spinner class="align-middle"></b-spinner>
          <strong class="pl-2">{{$t('viewJob.loading')}}</strong>
        </div>
      </div>
      <div v-else>
        <b-row class="page-content">
          <b-col cols="12">
            <job-details/>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col cols="12">
            <job-audio-file/>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col cols="12">
            <keyword-analysis-table/>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
  import JobDetails from '../components/jobDetails/JobDetails.vue';
  import JobAudioFile from '../components/jobDetails/JobAudioFile.vue';
  import KeywordAnalysisTable from '../components/jobDetails/KeywordAnalysisTable.vue';

  export default {
    components: {
      JobDetails,
      JobAudioFile,
      KeywordAnalysisTable,
    },
    data() {
      return {
        loading: true,
        jobId: this.$route.params.jobId,
      };
    },
    mounted() {
      this.getKeywordAnalysis();
    },
    methods: {
      getKeywordAnalysis() {
        this.$store.dispatch('keywordAnalysis/getKeywordAnalysisForJob', this.jobId)
          .then(() => {
            this.loading = false;
          })
          .catch(() => {
            this.$toasted.error('Error loading keyword analysis. Please refresh the pahe and try again.');
          });
      },
    },
  };
</script>

<style scoped>

</style>
